module.exports = {
  ACTIVE: 'ATIVA',
  DONE: 'CONCLUIDA',
  REMOVED_BY_RECEIVER: 'REMOVIDA_PELO_USUARIO_RECEBEDOR',
  REMOVED_BY_PSP: 'REMOVIDA_PELO_PSP'
};
